import React from 'react';
import {
  Box,
  Container,
  Paper,
  Skeleton,
  Grid
} from '@mui/material';

const SectorRotationSkeleton = () => {
  return (
    <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
      {/* Header */}
      <Box mb={3}>
        <Skeleton variant="text" width={300} height={40} />
        <Skeleton variant="text" width={500} height={24} sx={{ mt: 1 }} />
        <Box display="flex" gap={1.5} mt={2}>
          <Skeleton variant="rounded" width={150} height={32} />
          <Skeleton variant="rounded" width={200} height={32} />
        </Box>
      </Box>

      {/* Active Sectors Chips */}
      <Box display="flex" gap={1} mb={2} flexWrap="wrap">
        {[1, 2, 3, 4, 5].map((i) => (
          <Skeleton key={i} variant="rounded" width={120} height={32} />
        ))}
      </Box>

      {/* Money Flow Section */}
      <Paper elevation={0} sx={{ mb: 2, p: 2.5, border: '1px solid #f1f5f9' }}>
        <Skeleton variant="text" width={250} height={24} sx={{ mb: 2 }} />
        <Grid container spacing={3}>
          <Grid item xs={5}>
            {[1, 2, 3].map((i) => (
              <Skeleton key={i} variant="rounded" height={80} sx={{ mb: 1 }} />
            ))}
          </Grid>
          <Grid item xs={2} display="flex" alignItems="center" justifyContent="center">
            <Skeleton variant="circular" width={40} height={40} />
          </Grid>
          <Grid item xs={5}>
            {[1, 2, 3].map((i) => (
              <Skeleton key={i} variant="rounded" height={80} sx={{ mb: 1 }} />
            ))}
          </Grid>
        </Grid>
      </Paper>

      {/* Summary Cards */}
      <Box display="flex" gap={1} mb={2}>
        {[1, 2, 3, 4].map((i) => (
          <Paper key={i} elevation={0} sx={{ flex: 1, p: 2, border: '1px solid #f1f5f9' }}>
            <Skeleton variant="text" width="60%" height={20} />
            <Skeleton variant="text" width="80%" height={36} sx={{ mt: 1 }} />
          </Paper>
        ))}
      </Box>

      {/* Main Content Tabs */}
      <Paper elevation={0} sx={{ border: '1px solid #f1f5f9' }}>
        {/* Tabs */}
        <Box display="flex" gap={2} p={2} borderBottom="1px solid #f1f5f9">
          {[1, 2, 3, 4].map((i) => (
            <Skeleton key={i} variant="rounded" width={100} height={32} />
          ))}
        </Box>

        {/* Table Content */}
        <Box p={2}>
          {[1, 2, 3, 4, 5].map((i) => (
            <Box key={i} display="flex" gap={2} mb={2}>
              <Skeleton variant="text" width="20%" height={24} />
              <Skeleton variant="text" width="15%" height={24} />
              <Skeleton variant="text" width="15%" height={24} />
              <Skeleton variant="text" width="20%" height={24} />
              <Skeleton variant="text" width="30%" height={24} />
            </Box>
          ))}
        </Box>
      </Paper>
    </Container>
  );
};

export default SectorRotationSkeleton;
